import { skipToken, useQuery } from '@tanstack/react-query';
import { JiraIntegrationAPI } from '@/features/settings/work-integrations/api/jira';
import { workIntegrationsQueryKeys } from '@/features/settings/work-integrations/queryKeys';

export const useGetJiraItemLevelMappings = ({
  instanceId,
  enabled = true,
}: {
  instanceId?: string;
  enabled?: boolean;
}) => {
  return useQuery({
    queryKey: workIntegrationsQueryKeys.jiraItemLevelMappings({
      instanceId,
    }),
    queryFn: instanceId
      ? () =>
          JiraIntegrationAPI.getJiraItemLevelMappings({
            instanceId,
          })
      : skipToken,
    enabled,
  });
};
